import {
  Box,
  Button,
  IconButton,
  Input,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  HStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { FaCheckCircle, FaEye, FaTimesCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../config/axiosInstance";

const Tracktailor = () => {
  const [searchType, setSearchType] = useState("bill");
  const [query, setQuery] = useState("");
  const [result, setResult] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const navigate = useNavigate();

  const handleSearch = async () => {
    if (!query.trim()) return;

    setLoading(true);
    setSearched(false);
    try {
      const res = await axiosInstance.get(
        `/api/master-stats/tailor-order?search=${query}&searchType=${searchType}`
      );
      setResult(res.data.orders || []);
      setSearched(true);
    } catch (err) {
      setResult([]);
      setSearched(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={{ base: 4, md: 6 }} bg="gray.50" minH="100vh">
      <Box bg="white" p={6} rounded="md" boxShadow="sm" mb={6}>
        <Text fontWeight="bold" color="red.500" mb={2}>
          Track your order
        </Text>

        <HStack spacing={2} mb={4}>
          <Text
            fontWeight={searchType === "bill" ? "bold" : "normal"}
            cursor="pointer"
            onClick={() => setSearchType("bill")}
          >
            Bill number
          </Text>
          <Text color="gray.500">/</Text>
          <Text
            fontWeight={searchType === "phone" ? "bold" : "normal"}
            cursor="pointer"
            onClick={() => setSearchType("phone")}
          >
            Phone number
          </Text>
        </HStack>

        <Stack direction="row" spacing={3}>
          <Input
            placeholder={`Enter ${
              searchType === "bill" ? "Bill number" : "Phone number"
            }`}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <Button colorScheme="red" onClick={handleSearch} isLoading={loading}>
            Search
          </Button>
        </Stack>
      </Box>

      {searched && result.length === 0 && (
        <Box
          bg="white"
          p={6}
          rounded="md"
          boxShadow="sm"
          textAlign="center"
          mt={4}
        >
          <Text color="red.500" fontWeight="bold">
            No order found with this{" "}
            {searchType === "bill" ? "bill number" : "phone number"}
          </Text>
        </Box>
      )}

      {result.length > 0 && (
        <Box bg="white" p={6} rounded="md" boxShadow="sm" overflowX="auto">
          <Text mb={4}>
            Showing results for <b>{query}</b>
          </Text>
          <Table variant="simple" size="sm" minW="1000px">
            <Thead>
              <Tr>
                <Th>S.No</Th>
                <Th>Bill no</Th>
                <Th>Item</Th>
                <Th>Order Date</Th>
                <Th>Delivery Date</Th>
                <Th>Master</Th>
                <Th>Status</Th>
                <Th>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {result.map((order, index) => {
                const item = order.orderDetail;

                return (
                  <Tr key={order._id}>
                    <Td>{index + 1}</Td>
                    <Td>{order.billNumber}</Td>
                    <Td fontWeight="bold">{item.item}</Td>
                    <Td>{new Date(order.orderDate).toLocaleDateString()}</Td>
                    <Td>
                      {item.deliveryDate
                        ? new Date(item.deliveryDate).toLocaleDateString()
                        : "-"}
                    </Td>
                    <Td>{item.tailor?.name || "-"}</Td>
                    <Td>
                      {item.measurements.status === "done" ? (
                        <FaCheckCircle color="green" />
                      ) : (
                        <FaTimesCircle color="red" />
                      )}
                    </Td>
                    <Td>
                      <Stack direction="row" spacing={2}>
                        <IconButton
                          size="sm"
                          icon={<FaEye />}
                          aria-label="view"
                          onClick={() =>
                            navigate(`/dashboard/order/${order._id}`)
                          }
                        />
                      </Stack>
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </Box>
      )}
    </Box>
  );
};

export default Tracktailor;
